var getLowestMSRP = function getLowestMSRP(product) {
  if (product.attributes.msrp === null || product.attributes.msrp === undefined) {
    return null;
  }
  if (product.type === "configurable") {
    var cheapest = product.options.items.reduce(function (a, c) {
      var msrp = c.product.attributes.msrp;
      if (typeof msrp === "number") {
        if (a === null) {
          return msrp;
        }
        if (msrp < a) {
          return msrp;
        }
      }
      return a;
    }, null);
    return cheapest;
  }
  return product.attributes.msrp;
};

export { getLowestMSRP };
//# sourceMappingURL=utils.js.map
